import {
  STORE_PLANT_ITEMS,
  STORE_PLANT_DETAILS,
  STORE_ASSOCIATED_DESIGN,
  STORE_RELATED_DETAILS,
  REMOVE_PLANT_ITEM,
  RESET_ASSOCIATED_DESIGN,
  RESET_RELATED_DETAILS,
  ADD_PLANT_ITEM,
} from 'plantItemNew/redux/actions';

const initialState = {
  location: undefined,
  items: [],
};

export const plantItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_PLANT_ITEMS:
      return {
        ...state,
        ...action.payload,
      };

    case ADD_PLANT_ITEM:
      return {
        ...state,
        items: state.items.concat({ itemDetails: action.payload }),
      };
    case STORE_PLANT_DETAILS:
      return {
        ...state,
        items: state.items.map((e, i) => {
          if (i === parseInt(action.payload.index)) {
            return { ...e, itemDetails: action.payload.data };
          } else {
            return e;
          }
        }),
      };

    case STORE_ASSOCIATED_DESIGN:
      return {
        ...state,
        items: state.items.map((e, i) => {
          if (i === parseInt(action.payload.index)) {
            return { ...e, designDetails: action.payload.data };
          } else {
            return e;
          }
        }),
      };

    case STORE_RELATED_DETAILS:
      return {
        ...state,
        items: state.items.map((e, i) => {
          if (i === parseInt(action.payload.index)) {
            return { ...e, relatedDetails: action.payload.data };
          } else {
            return e;
          }
        }),
      };

    case RESET_ASSOCIATED_DESIGN:
      return {
        ...state,
        items: state.items.map((e, i) => {
          if (i === parseInt(action.payload.index)) {
            return { ...e, designDetails: undefined };
          } else {
            return e;
          }
        }),
      };

    case RESET_RELATED_DETAILS:
      return {
        ...state,
        items: state.items.map((e, i) => {
          if (i === parseInt(action.payload.index)) {
            return { ...e, relatedDetails: undefined };
          } else {
            return e;
          }
        }),
      };

    case REMOVE_PLANT_ITEM:
      return {
        ...state,
        items: state.items.filter((e, i) => i !== action.payload.index),
      };

    case 'application/getApplication/fulfilled':
      return {
        ...action.payload.applicationData.plantItems,
      };
    case 'form/clearForm':
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
